// Inline styles inherit the approved active brand when they are rendered below
// `.bl-brand-surface`. Exact legacy values remain as CSS fallbacks everywhere
// else, so dormant product surfaces keep their existing presentation.
export const PALETTE = {
  bg: 'var(--active-bg, #FAF8F5)',
  surface: 'var(--active-surface, #FFFFFF)',
  surfaceAlt: 'var(--active-surface-alt, #F3EFE8)',
  ink: 'var(--active-ink, #1A1714)',
  ink2: 'var(--active-ink-2, #55504A)',
  ink3: 'var(--active-ink-3, #8A8078)',
  line: 'var(--active-line, #E7E0D6)',
  lineSoft: 'var(--active-line-soft, #EFEAE1)',
  controlBorder: 'var(--active-control-border, #E7E0D6)',
  accent: 'var(--active-accent-text, #E06A2C)',
  accentDeep: 'var(--active-accent-deep, #B8501A)',
  accentSoft: 'var(--active-accent-soft, #FBE7D6)',
  accentTint: 'var(--active-accent-tint, #FDF4EC)',
  success: 'var(--active-success, #5F7A3D)',
  successSoft: 'var(--active-success-soft, #E8EEDC)',
  warn: 'var(--active-warn, #B8822C)',
  warnSoft: 'var(--active-warn-soft, #FBEFD6)',
  danger: '#A33333',
  dangerSoft: '#F7E0DA',
  sevHigh: '#C4562A',
  sevMed: '#B8822C',
  sevLow: '#5F7A3D',
};
